Namespace 'Monitoring.Reports.Publications.Sections'

class Monitoring.Reports.Publications.Sections.PageResumenView extends Backbone.View

  tagName: 'section'
  template: JST['backbone/templates/monitoring/reports/publications/section']
  pageResumenTemplate: JST['backbone/templates/monitoring/reports/publications/page_resumen']
  twitterPageResumenTemplate: JST['backbone/templates/monitoring/reports/publications/twitter_page_resumen']

  initialize: (@options = {}) ->
    # just set @options
  render_twitter:->
    @$el.html(@template(@options))
    @template = @twitterPageResumenTemplate
    @

  render: ->
    @$el.html(@template(@options))
    @template = @pageResumenTemplate
    @

  fill_page_resumen: (data) ->
    reach_metrics = [data[0], data[1], data[2], data[3]]
    fans_metrics = [data[8], data[6], data[5], data[4], data[7]]
    @$('.section-body-container').append(@pageResumenTemplate({ reach_metrics, fans_metrics }))
    @

  fill_twitter_page_resumen: (data)->
    @$('.section-body-container').append(@twitterPageResumenTemplate({ metrics: data}))
    @

  fail: =>
    # TODO generic template (with content_view)
    error_message = I18n.t("monitoring.dashboard.publications.error")
    @$('.spinner').replaceWith("<div class='error'><i class='fa fa-exclamation-triangle'></i> #{error_message}</div>")
